<div class="list-with-image__container">
    <div class="list-with-image__row">
        <div class="list-with-image__title" [innerHTML]="tileList" l10nTranslate></div>
        <div class="list-with-image__description" [innerHTML]="descriptionList" l10nTranslate></div>
    </div>
    <div class="list-with-image__cards">
        <div class="list-with-image__card-one">

            <ng-container *ngFor="let item of items">
                <div class="list-with-image__card-one-holder">
                    <img src="../../../../assets/images/Eo_circle_light-blue_checkmark.svg.png">
                    <div  [innerHtml]="item" l10nTranslate></div>
                </div>
            </ng-container>

        </div>
        <div class="list-with-image__card-two">
            <img [src]="imgListPath">
        </div>
    </div>
</div>
<div class="list-with-image__buttons">
    <button class="list-with-image__btn-contact-us" [routerLink]="[routerListButton]" l10nTranslate>{{buttonListText}}</button>
</div>